import { getLoaderEndpoint } from "@app/framework/loader";
import { pageHead } from "@app/framework/meta";
import { PressReleasesPage } from "@app/modules/press-releases/pages";
import { getPressReleasesService } from "@modules/press-releases/services";
import { trans } from "@mongez/localization";
import { LoaderFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export const loader: LoaderFunction = async ({ request }) => {
  const { http, success, catchErrors } = await getLoaderEndpoint(request);

  try {
    const response = await getPressReleasesService(http);

    return success(response);
  } catch (error: any) {
    return catchErrors(error);
  }
};

export default function PressReleases() {
  const data = useLoaderData<any>();

  return <PressReleasesPage news={data.news} />;
}

export const meta = () => {
  return pageHead({
    title: trans("pressReleases"),
  });
};
